module.exports = __webpack_public_path__ + "static/media/collapseAll.70203b7f.svg";